export default __webpack_public_path__ + "static/media/share-twitter-icon.f6f3988c.svg";